<script>
  import Page from '@components/page'
  import Block from '@components/general/block'
  import Button from '@components/buttons/button.svelte'
  import BoxedText from '@components/general/boxed-text.svelte'
  import OfferForm from '@components/offers/form.svelte'
  import OffersTable from '@components/offers/table.svelte'
  import MembersPreviewModal from '@components/programmes/members-preview-modal.svelte'
  import { BookOpen, Pencil, Users } from 'lucide-svelte'
  import { formatDateText } from '@lib/utils/date'

  let { programme } = $props()

  let showOfferForm = $state(false)
  let showMembersPreview = $state(false)
  let selectedOffer = $state(null)

  function editOffer(offer) {
    selectedOffer = offer
    showOfferForm = true
  }

  function closeOfferForm() {
    selectedOffer = null
    showOfferForm = false
  }

  function statusVariant(programme) {
    if (!programme.active) return "default"
    if (programme.current) return "success"
    return "warning"
  }

  function statusLabel(programme) {
    if (!programme.active) return "Inactive"
    if (programme.current) return "Active"
    return "Upcoming"
  }
</script>

<Page.Layout title={programme.name}>

  <Page.Navigation title={programme.name} Icon={BookOpen} links={[
    { text: "Admin", href: "/admin" },
    { text: "Programmes", href: "/admin/programmes" }
  ]} />

  <Page.Titles title={programme.name} subtitle={programme.key}>
    {#snippet buttons()}
      <Button text="View members" Icon={Users} onclick={() => showMembersPreview = true} />
      <Button text="Edit programme" Icon={Pencil} path={`/admin/programmes/${programme.id}/edit`} />
    {/snippet}
  </Page.Titles>

  <Page.Content>

    {#snippet main()}

      <!-- Programme details -->
      <Block.Element label="Programme details" title={programme.name}>
        <Block.Items>
          <Block.Item label="Key" value={programme.key} />
          <Block.Item label="Starts" value={formatDateText(programme.starts_on)} />
          <Block.Item label="Ends" value={formatDateText(programme.ends_on)} />
          <Block.Item label="Status">
            <BoxedText variant={statusVariant(programme)} size="xs" text={statusLabel(programme)} />
          </Block.Item>
          {#if programme.stripe_product_id}
            <Block.Item label="Stripe product" value={programme.stripe_product_id} />
          {/if}
        </Block.Items>

        {#if programme.description?.html}
          <div class="prose prose-sm mt-4 pt-4 border-t border-gray-100">
            {@html programme.description.html}
          </div>
        {/if}
      </Block.Element>

    {/snippet}

    {#snippet aside()}

      <!-- Stats -->
      <Block.Element label="Membership stats" title="Members">
        <Block.Items>
          <Block.Item label="Total memberships" value={programme.memberships_count} />
          <Block.Item label="Active memberships" value={programme.active_memberships_count} />
          <Block.Item label="Offers" value={programme.offers?.length || 0} />
        </Block.Items>
        {#if programme.memberships?.length > 0}
          <Button variant="link" text="View all members" BeforeIcon={Users} onclick={() => showMembersPreview = true} class="mt-4 text-gray-500" />
        {/if}
      </Block.Element>

    {/snippet}

  </Page.Content>

  <!-- Offers (full width) -->
  <Page.Content>
    {#snippet children()}
      <OffersTable {programme} onEdit={editOffer} onCreate={() => showOfferForm = true} />
    {/snippet}
  </Page.Content>

</Page.Layout>
<OfferForm
<OfferForm bind:open={showOfferForm} offer={selectedOffer} {programme} onClose={closeOfferForm} />
<MembersPreviewModal bind:open={showMembersPreview} memberships={programme.memberships} />
